module.exports = __webpack_public_path__ + "img/desktop-7.f79fc8f3.jpg";